import { Step as MuiStep, StepProps as MuiStepProps } from '@mui/material';
import React from 'react';

export type StepProps = MuiStepProps;

export const Step = (props: StepProps) => {
  return <MuiStep {...props} />;
};
